function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t\t.st0{fill:none;}\n\t");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "pos"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0,200 32.65,200 32.65,100 200,0 0,0  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "200,0 367.35,100 367.35,200 400,200 400,0  "
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1_copy",
  className: "neg"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "32.65,200 32.65,100 200,0 367.35,100 367.35,200  "
}));

var SvgShapeDemiHexagon = props => /*#__PURE__*/React.createElement("svg", _extends({
  x: "0px",
  y: "0px",
  width: "400px",
  height: "200px",
  viewBox: "0 0 400 200",
  style: {
    enableBackground: "new 0 0 400 200"
  },
  xmlSpace: "preserve"
}, props), _ref, _ref2, _ref3);

export default __webpack_public_path__ + "static/media/shape-demi_hexagon.c22dbd5a.svg";
export { SvgShapeDemiHexagon as ReactComponent };